import { z } from 'my-zod'
import { operatorSystemView } from '../../outfitter-account-management/outfitter'

export const reservationDepositPolicyFragment = operatorSystemView.pick({
  id: true,
  reservationDepositAmount: true,
  reservationDepositUnit: true
})

export type reservationDepositPolicyFragment = z.infer<typeof reservationDepositPolicyFragment>
